import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { styles } from '../../../utils/styles';

var _ref = /*#__PURE__*/React.createElement(View, null);

export const FrequencyPDF = ({
  carePlan
}) => /*#__PURE__*/React.createElement(View, {
  style: styles.width20
}, carePlan && carePlan.frequencyText && /*#__PURE__*/React.createElement(Text, {
  style: styles.CPFTableDetailsText
}, `${carePlan.frequencyText}`) || _ref);